<template>
	<Header :title="props.title" class="modal-header" :back="props.back">
		<template v-slot:right="{goBack}">
			<button class="modal-header__close" @click="goBack" type="button">
				<Icon name="close" />
			</button>
		</template>
	</Header>
	<slot></slot>
	<Footer />
	<Menu />
</template>
<script lang="ts" setup>
import "./ModalLayout.scss";
import Footer from "@/components/Footer/Footer.vue";
import Menu from "@/components/Menu/Menu.vue";
import Header from "@/components/Header/Header.vue";
import Icon from "@/components/Icon/Icon.vue";

interface Props{
	title : string,
	back? : string | boolean | Function
}

let props = withDefaults(defineProps<Props>(), {
	back : false
})

</script>